import React, {useState} from "react";
import {useTranslation} from "@unibuddy/intl";
import {Select, Stack, Label} from "@unibuddy/patron";
import useAnalytics from "shared/AnalyticsNew/hooks/useAnalytics";
import {sharedEvents} from "shared/AnalyticsNew/constants/productSpecification";

import {IntlNamespaces} from "../../../../translations/types";
import {INTL_DATE_PUBLISHED, INTL_MOST_VIEWED, INTL_SORT} from "../../../../translations/blogs";
import {useUniversity} from "../../UniversityProvider/UniversityProvider";

type SortInputProps = {
    currentSort: string;
    onSearch: (sort: string, filter: string, isOptionMenu?: boolean) => void;
};

type BlogPostSortKeysType = {
    label: string;
    value: string;
};

export const SortInput = ({currentSort, onSearch}: SortInputProps) => {
    const {t} = useTranslation([IntlNamespaces.BLOGS]);
    const [selectedSort, setSelectedSort] = useState<string>(currentSort);
    const {trackEvent} = useAnalytics();
    const {slug: universitySlug} = useUniversity();

    const BLOG_POST_SORT_KEYS: BlogPostSortKeysType[] = [
        {label: t(INTL_DATE_PUBLISHED.key, INTL_DATE_PUBLISHED.defaultValue), value: "-modified"},
        {label: t(INTL_MOST_VIEWED.key, INTL_MOST_VIEWED.defaultValue), value: "-views"},
    ];

    const onChange = (event: {target: {value: string}}) => {
        setSelectedSort(event.target.value);
        onSearch(event.target.value, "sort");
        trackEvent(sharedEvents.contentSorted.name, {
            universitySlug,
            sortOption: event.target.value,
        });
    };

    return (
        <Stack space="xsmall">
            <Label id="sort">{t(INTL_SORT.key, INTL_SORT.defaultValue)}</Label>
            <Select id="sort" value={selectedSort} onChange={onChange} formatValue={(e) => e}>
                {BLOG_POST_SORT_KEYS.map((sort: BlogPostSortKeysType) => (
                    <option value={sort.value} key={sort.value}>
                        {sort.label}
                    </option>
                ))}
            </Select>
        </Stack>
    );
};
